import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index/index.vue'),
    meta: { title: '首页', activeIndex:0 },
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import('../views/sceneSolution/index.vue'),
    meta: { title: '应急场景&解决方案', activeIndex:1 },
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/shopping/List.vue'),
    meta: { title: '列表页' },
  },
  {
    path: '/shopping',
    name: 'shopping',
    component: () => import('../views/shopping/index.vue'),
    meta: { title: '精品商城', activeIndex:2 },
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("../views/shopping/detail.vue"),
    meta: { title: "detail" },
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('../views/aboutUs/index.vue'),
    meta: { title: '关于我们', activeIndex:3 },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/login.vue"),
    meta: { title: "登录" },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/login/register.vue"),
    meta: { title: "注册" },
  },
  {
    path: "/reset",
    name: "reset",
    component: () => import("../views/login/reset.vue"),
    meta: { title: "重置密码" },
  },
  {
    path: "/personal",
    name: "personal",
    component: () => import("../views/personal/index.vue"),
    meta: { title: "个人中心" },
  },
  {
    path: "/myshop",
    name: "myshop",
    component: () => import("../views/personal/myshop.vue"),
    meta: { title: "我的购物车" },
  },
  {
    path: "/order",
    name: "order",
    component: () => import("../views/personal/order.vue"),
    meta: { title: "订单管理" },
  },
  {
    path: "/address",
    name: "address",
    component: () => import("../views/personal/address.vue"),
    meta: { title: "收货地址" },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/personal/profile.vue"),
    meta: { title: "个人资料" },
  },
  {
    path: "/orderDetail",
    name: "orderDetail",
    component: () => import("../views/personal/orderDetail.vue"),
    meta: { title: "订单详情" },
  },
  {
    path: "/confirm",
    name: "confirm",
    component: () => import("../views/personal/confirm.vue"),
    meta: { title: "确认订单" },
  },
  {
    path: "/solutionFin",
    name: "solutionFin",
    component: () => import("../views/sceneSolution/solution.vue"),
    meta: { title: "解决方案" },
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL), // 修改：使用createWebHashHistory替代createWebHistory
  routes,
})

router.beforeEach((to, from, next) => {
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  next()
})

export default router
